import type { ReactNode } from 'react';

export function Spinner({ label }: { label?: string }) {
  return <div className="state" role="status"><div className="spinner" />{label && <div className="muted small">{label}</div>}</div>;
}

export function EmptyState({ title, children, glyph = '·' }: { title: string; children?: ReactNode; glyph?: string }) {
  return <div className="state"><div className="glyph">{glyph}</div><div className="title">{title}</div>{children && <div className="small">{children}</div>}</div>;
}

export function ErrorState({ title = 'Something went wrong', error, retry }: { title?: string; error?: unknown; retry?: () => void }) {
  const msg = error instanceof Error ? error.message : typeof error === 'string' ? error : undefined;
  return (
    <div className="state error">
      <div className="glyph">!</div>
      <div className="title">{title}</div>
      {msg && <div className="small muted">{msg}</div>}
      {retry && <button className="btn sm" onClick={retry}>Try again</button>}
    </div>
  );
}

export function Chip({ kind, children }: { kind?: string; children: ReactNode }) {
  return <span className={`chip ${kind ?? ''}`}>{children}</span>;
}

export function timeAgo(iso: string | undefined, now = Date.now()): string {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const s = Math.max(0, Math.round((now - t) / 1000));
  if (s < 45) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  if (d < 14) return `${d} d ago`;
  return new Date(t).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDate(iso: string | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatBytes(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return '0 B';
  let v = n;
  let i = 0;
  while (v >= 1024 && i < BYTE_UNITS.length - 1) { v /= 1024; i++; }
  return `${i === 0 ? v : v.toFixed(1)} ${BYTE_UNITS[i]}`;
}
